import {styledByTheme} from "../../../themes/architecture/styled-by-theme";
import {RouterOutletDefaultBox} from "./router-outlet.default.box";
import {RouterOutletCasino777Box} from "./router-outlet.casino777.box";
import {RouterOutletCasino888Box} from "./router-outlet.casino888.box";
import {RouterOutletHarrahsBox} from "./router-outlet.harrahs.box";
import {RouterOutletWsopBox} from "./router-outlet.wsop.box";
import {RouterOutletSIBox} from "./router-outlet.si.box";


export const RouterOutletBox = styledByTheme(RouterOutletDefaultBox)
    .forCasino888(RouterOutletCasino888Box)
    .forCasino777(RouterOutletCasino777Box)
    .forHarrahs(RouterOutletHarrahsBox)
    .forWsop(RouterOutletWsopBox)
    .forSI(RouterOutletSIBox)
    .apply();